import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../../../interfaces/IReduxState";

export const Subject_Drive_MapCreate_UpdateSlice = createSlice({
  name: "Subject_Drive_MapCreate_UpdateSlice",
  initialState: {} as IReduxState<any>,
  reducers: {
    Subject_Drive_MapCreate_Update: (state, _: PayloadAction<any>) => {
      state.isLoading = true;
    },
    successSubject_Drive_MapCreate_Update: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureSubject_Drive_MapCreate_Update: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearSubject_Drive_MapCreate_Update: (state) => {
      state.data = {};
    },
  },
});

export const {
  Subject_Drive_MapCreate_Update,
  failureSubject_Drive_MapCreate_Update,
  successSubject_Drive_MapCreate_Update,
  clearSubject_Drive_MapCreate_Update,
} = Subject_Drive_MapCreate_UpdateSlice.actions;

export default Subject_Drive_MapCreate_UpdateSlice.reducer;
